import { createRequestPacer } from "utils/requestPacer"

/**
 * The shared budget for /truck-fix-cost, spent by BOTH the AI read and the save — reading
 * 26 ป้ายวงกลม and then uploading 26 certificates is one long burst on one path, so it has
 * to be one counter.
 *
 * 20 of the path's 30 per minute. The 10 left over cover the list refresh behind the
 * dialog and a second operator on the same office IP; the limiter counts by IP, not by
 * user, so the whole branch shares it.
 */
export const truckFixCostPacer = createRequestPacer({ max: 20 })

export default truckFixCostPacer
